import { DateFormat } from "@constants/format";
import { Text, View } from "@react-pdf/renderer";
import { format } from "date-fns";
import { useMemo } from "react";
import { RenderPDFItemProps } from "@models/platform-analysis/entities/steps/summary";
import { PDFStyleConfigs } from "../../export-pdf/configs";
import { useTheme } from "@mui/material";
import { useAnalysisPDFStyles } from "@hooks/useAnalysisPDFStyle";

export const PDFAdviserInformation = ({ analysis }: RenderPDFItemProps) => {
  const { typographyStyle } = useAnalysisPDFStyles();
  const { palette } = useTheme();

  const {
    name,
    ownerName,
    ownerARN,
    lastModifiedDate,
    serial,
    firmName,
    firmAfsl,
    familyGroupName,
    familyMembersNames,
  } = useMemo(() => {
    const {
      name,
      ownerName,
      ownerARN,
      lastModifiedDate,
      serial,
      firmName,
      firmAFSL,
      familyGroupName,
      familyMembersNames,
    } = analysis.summary || {};

    return {
      name: name || "",
      ownerName: ownerName || "",
      ownerARN: ownerARN || "",
      lastModifiedDate: lastModifiedDate || new Date(),
      serial: serial || "",
      firmName: firmName || "",
      firmAfsl: firmAFSL || "",
      familyGroupName: familyGroupName || "",
      familyMembersNames: familyMembersNames || [],
    };
  }, [analysis.summary]);

  return (
    <View
      style={{
        justifyContent: "space-between",
        alignItems: "flex-start",
        flexDirection: "column",
        height:
          PDFStyleConfigs.ReviewFirstPageBodyHeight - PDFStyleConfigs.GapLarge,
      }}
    >
      <Text
        style={{
          ...typographyStyle.title,
          color: palette.common.white,
          fontSize: 24,
        }}
      >
        {name}
      </Text>

      <View style={{ gap: PDFStyleConfigs.GapMedium }}>
        <View style={{ gap: PDFStyleConfigs.GapSmall }}>
          {" "}
          <Text
            style={{
              ...typographyStyle.title,
              color: palette.common.white,
              fontSize: "13px",
            }}
          >
            {`This Suitability Review is for ${familyGroupName} and the following individuals/entities:`}
          </Text>
          <Text
            style={{
              ...typographyStyle.title,
              color: palette.common.white,
              fontWeight: "normal",
              fontSize: "13px",
            }}
          >
            {familyMembersNames.join(", ").replace(/, (?!.*,)/g, " and ")}
          </Text>
        </View>

        <View style={{ gap: PDFStyleConfigs.GapSmall }}>
          <Text
            style={{
              ...typographyStyle.title,
              color: palette.common.white,
              fontWeight: "normal",
              fontSize: "13px",
            }}
          >
            {`Prepared by: `}
            <Text style={{ fontWeight: "bold" }}>{ownerName}</Text>
            {` of `}
            <Text style={{ fontWeight: "bold" }}>{firmName}</Text>
          </Text>
          <Text
            style={{
              ...typographyStyle.subtitle,
              color: palette.common.white,
              fontSize: "11px",
            }}
          >
            {ownerARN && (
              <Text>
                ARN:
                <Text
                  style={{ fontWeight: "normal" }}
                >{` ${ownerARN}  |  `}</Text>
              </Text>
            )}
            {firmAfsl && (
              <Text>
                AFSL No.
                <Text style={{ fontWeight: "normal" }}>{firmAfsl}</Text>
              </Text>
            )}
          </Text>
        </View>

        <Text
          style={{
            ...typographyStyle.subtitle,
            color: palette.common.white,
            fontWeight: "normal",
            fontSize: "11px",
          }}
        >
          {`${
            lastModifiedDate
              ? `Last edit: ${format(new Date(lastModifiedDate), DateFormat)}`
              : ""
          }  |  ${
            analysis.databaseVersion
              ? `Data valid: ${format(
                  new Date(analysis.databaseVersion),
                  DateFormat,
                )}`
              : ""
          } |  Serial: ${serial}`}
        </Text>
      </View>
    </View>
  );
};
